import { Component } from 'react';
import classnames from 'classnames';
import { FormControl, FormHelperText, TextField } from '@mui/material';
import { withStyles } from '@mui/styles';
import IconButton from "@mui/material/IconButton";
import ErrorIcon from './assets/icon-error.svg';
import ValidIcon from './assets/icon-tick-outline.svg';
import { ReactComponent as Visibility } from "./assets/VisibilityIcon.svg";
import { ReactComponent as VisibilityOff } from "./assets/VisibilityOffIcon.svg";
import APInputStyles from './styles/APInput.style';
import APPasswordCriteria from '../APPasswordCriteria/APPasswordCriteria';
import { MASK_CLASS, TAX_NUMBER_FIELD_NAME } from '../../../core/utils/Constants/Constants';

class APInput extends Component<any, {}> {
  state = {
    touched: false,
    passwordIsMasked: true
  };

  constructor(props: any) {
    super(props);
    this.onBlur = this.onBlur.bind(this);
    this.togglePasswordMask = this.togglePasswordMask.bind(this);
  }

  onBlur(...args: any[]) {
    const {
      onBlur
    } = this.props;

    this.setState({
      touched: true
    });

    if (onBlur) {
      onBlur(...args);
    }
  }

  togglePasswordMask = () => {
    this.setState({
      passwordIsMasked: !this.state.passwordIsMasked,
    });
  };

  render() {
    const {
      classes,
      className,
      error,
      helperText,
      passwordCriteria,
      diabledAutofill,
      inputProps,
      type,
      supportsUnmasking = false,
      isCoralogixMasked,
      ...others
    } = this.props;

    const props = {
      ...others,
      variant: "outlined" as "outlined"
    };

    const controlCls = classnames(classes.formControl, className);
    const inputTextTransformStyle = this.props.name === TAX_NUMBER_FIELD_NAME ? 'uppercase' : 'initial';
    let inputType: string = type;
    if (type === 'password' && supportsUnmasking) {
      inputType = this.state.passwordIsMasked ? 'password' : 'text';
    }

    return (
      <FormControl className={controlCls}>
        {supportsUnmasking &&
          (<IconButton
            aria-label="toggle password visibility"
            onClick={this.togglePasswordMask}
            edge="end"
            className={classes.passwordEyeIcon}
            size="large"
          >
            {this.state.passwordIsMasked ? <Visibility /> : <VisibilityOff />}
          </IconButton>)
        }
        <TextField
          {...props}
          error={error}
          onBlur={this.onBlur}
          type={inputType}
          inputProps={
            {
              style: {
                textTransform: inputTextTransformStyle
              },
              "data-testid": "selectedInput",
              className: isCoralogixMasked ? MASK_CLASS : "",
            }
          }
        />
        {helperText && (
          <FormHelperText className={classes.helperText} error={error}>
            {helperText}
          </FormHelperText>
        )}
        {error && (
          <img className={classes.stateIcon} src={ErrorIcon} alt="Invalid input icon" />
        )}
        {this.state.touched && !error && (
          <img className={classes.stateIcon} src={ValidIcon} alt="Valid input icon" />
        )}

        {passwordCriteria &&
          <APPasswordCriteria inputValue={this.props.value} />
        }
      </FormControl>
    );
  }
}

export default withStyles(APInputStyles)(APInput);
